export default "__VITE_ASSET__8814bf62__"